import { DefaultLocale, normalizeSupportedLocale, } from "./locales.js";
export const LegalDocsMetadata = [
    {
        contentKey: "legal:terms",
        content: {
            localePolicy: "shared",
            source: { path: "content/legal/terms.md", locale: "en-US" },
        },
        slug: "terms",
        icon: "contract",
        titleKey: "legal.terms.title",
        descriptionKey: "legal.terms.description",
        categoryKey: "legal.terms.category",
        readTimeKey: "legal.terms.read_time",
        sitemap: { changefreq: "yearly", priority: 0.4 },
    },
    {
        contentKey: "legal:privacy",
        content: {
            localePolicy: "shared",
            source: { path: "content/legal/privacy.md", locale: "fr-FR" },
        },
        slug: "privacy",
        icon: "privacy_tip",
        titleKey: "legal.privacy.title",
        descriptionKey: "legal.privacy.description",
        categoryKey: "legal.privacy.category",
        readTimeKey: "legal.privacy.read_time",
        sitemap: { changefreq: "yearly", priority: 0.4 },
    },
    {
        contentKey: "legal:security",
        content: {
            localePolicy: "shared",
            source: { path: "content/legal/security.md", locale: "fr-FR" },
        },
        slug: "security",
        icon: "shield_lock",
        titleKey: "legal.security.title",
        descriptionKey: "legal.security.description",
        categoryKey: "legal.security.category",
        readTimeKey: "legal.security.read_time",
        sitemap: { changefreq: "yearly", priority: 0.4 },
    },
    {
        contentKey: "legal:disponibility",
        content: {
            localePolicy: "shared",
            source: { path: "content/legal/disponibility.md", locale: "fr-FR" },
        },
        slug: "disponibility",
        icon: "cloud_done",
        titleKey: "legal.disponibility.title",
        descriptionKey: "legal.disponibility.description",
        categoryKey: "legal.disponibility.category",
        readTimeKey: "legal.disponibility.read_time",
        sitemap: { changefreq: "yearly", priority: 0.4 },
    },
];
export const PublicContentSources = [
    ...LegalDocsMetadata,
].map((doc) => ({
    contentKey: doc.contentKey,
    ...doc.content,
}));
const PublicContentSourceByKey = new Map(PublicContentSources.map((source) => [source.contentKey, source]));
function createPublicContentId(scope, contentKey, locale) {
    return locale
        ? `${scope}:${contentKey}:${locale.toLowerCase()}`
        : `${scope}:${contentKey}`;
}
export function getPublicContentSourcePaths(sources = PublicContentSources) {
    return Array.from(new Set(sources.flatMap((source) => (source.localePolicy === "shared"
        ? [source.source.path]
        : Object.values(source.sources).map((variant) => variant.path)))));
}
export function resolvePublicContentSource(source, locale = DefaultLocale) {
    const requestedLocale = normalizeSupportedLocale(locale);
    if (source.localePolicy === "shared")
        return {
            contentKey: source.contentKey,
            contentId: createPublicContentId("shared", source.contentKey),
            requestedLocale,
            sourcePath: source.source.path,
            sourceLocale: source.source.locale,
            shared: true,
        };
    const variant = source.sources[requestedLocale];
    return {
        contentKey: source.contentKey,
        contentId: createPublicContentId("localized", source.contentKey, requestedLocale),
        requestedLocale,
        sourcePath: variant.path,
        sourceLocale: requestedLocale,
        shared: false,
    };
}
export function getPublicContentSource(contentKey, locale = DefaultLocale) {
    const source = PublicContentSourceByKey.get(contentKey);
    if (!source)
        return null;
    return resolvePublicContentSource(source, locale);
}
//# sourceMappingURL=content.js.map